import { ReactComponent as LockIcon } from 'components/icons/lock.svg';
import React from 'react';
import { LockWrapper } from './LockedIconStyles';
import { Tooltip } from '@mui/material';

const LockedIcon = () => {
  return (
    <LockWrapper>
      <Tooltip title='Session currently being edited by Session Review' arrow>
        <LockIcon />
      </Tooltip>
    </LockWrapper>
  );
};

export default LockedIcon;
